var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path0, _path1, _g6, _path10, _path11, _path12, _g7, _path13, _g8, _path14, _path15, _g9, _path16, _path17, _g0, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPikkopay2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 145,
    viewBox: "0 0 84 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79182 34.3935C5.79182 34.3935 35.858 32.3335 36.0627 64.6596C3.7353 64.4546 5.79182 34.3935 5.79182 34.3935Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 31,
    width: 36,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93359 31.7891H38.4757V66.6972H3.93359V31.7891Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8189 66.4317L36.0509 66.4224C25.624 66.3525 17.5143 63.2811 11.9449 57.2782C3.22565 47.8871 4.01197 34.8373 4.04919 34.2873L4.15155 32.7726L5.673 32.6654C5.673 32.6654 6.10106 32.6328 6.8548 32.6328C11.9915 32.6328 37.6142 34.1801 37.8096 64.6607L37.8189 66.4317Z",
    fill: "url(#paint0_linear_5396_20390)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 0,
    width: 26,
    height: 49
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9453 0.0234375H53.9586V48.4893H28.9453V0.0234375Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5988 47.8771L40.3565 46.6187C33.0284 39.199 29.469 31.2899 29.7761 23.1105C30.2553 10.3031 40.0354 1.63434 40.4542 1.27547L41.5988 0.273438L42.748 1.27547C43.1668 1.63434 52.9469 10.3031 53.4261 23.1105C53.7332 31.2899 50.1738 39.199 42.8457 46.6187L41.5988 47.8771Z",
    fill: "url(#paint1_linear_5396_20390)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2591 34.3935C78.2591 34.3935 48.1977 32.3335 47.9883 64.6596C80.3203 64.4546 78.2591 34.3935 78.2591 34.3935Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 31,
    width: 36,
    height: 36
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6211 31.7891H80.1632V66.6972H45.6211V31.7891Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2305 66.4317L46.2444 64.6607C46.4398 34.1801 72.0626 32.6328 77.1946 32.6328C77.953 32.6328 78.381 32.6654 78.381 32.6654L79.8978 32.7726L80.0049 34.2873C80.0421 34.8373 80.8284 47.8824 72.1091 57.2782C66.5444 63.2811 58.43 66.3525 47.9985 66.4224L46.2305 66.4317Z",
    fill: "url(#paint2_linear_5396_20390)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 51,
    width: 82,
    height: 94
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54297 51.6328H82.5382V145.004H1.54297V51.6328Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5396_20390)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 51,
    width: 80,
    height: 95
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.573 145.01V51.714C56.2985 51.6953 56.0287 51.6953 55.7542 51.6953H28.3587V145.01H56.573ZM21.3377 145.01H28.3587V51.714H28.2052C16.8524 51.714 6.88621 60.9933 6.06733 72.3233L2.2288 124.424C1.38665 135.731 9.9896 145.01 21.3377 145.01ZM62.617 145.01C73.9697 145.01 82.568 135.731 81.7305 124.401L77.8873 72.3046C77.0685 61.2496 67.5536 52.1474 56.5544 51.714V145.01H62.617Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7888 145.012H2.22656V51.6406H81.7888V145.012Z",
    fill: "#FFDE59"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 49,
    width: 37,
    height: 37
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 49.2734H36.6386V85.5984H0.375V49.2734Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5396_20390)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 49,
    width: 37,
    height: 37
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5068 49.2812C8.49407 49.2812 0.375 57.4094 0.375 67.4437C0.375 77.4734 8.49407 85.6062 18.5068 85.6062C28.5195 85.6062 36.6386 77.4734 36.6386 67.4437C36.6386 57.4094 28.5195 49.2812 18.5068 49.2812Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.375 49.2812H36.6386V85.6062H0.375V49.2812Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 56,
    width: 23,
    height: 23
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21484 56.0859H29.8273V78.7413H7.21484V56.0859Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5396_20390)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 56,
    width: 23,
    height: 23
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.525 56.0859C12.281 56.0859 7.21875 61.1567 7.21875 67.4159C7.21875 73.6705 12.281 78.7413 18.525 78.7413C24.769 78.7413 29.8312 73.6705 29.8312 67.4159C29.8312 61.1567 24.769 56.0859 18.525 56.0859Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 56.0859H29.8312V78.7413H7.21875V56.0859Z",
    fill: "#3D1F1E"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.367 69.3555C14.367 66.6294 16.3959 64.6643 19.0582 64.6643C16.5196 64.6643 14.3691 62.571 14.3691 59.9709C14.3691 62.5462 12.3622 64.6643 9.67578 64.6643C12.3622 64.6643 14.367 66.7284 14.367 69.3555Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.367 59.9688L14.3691 59.9709M14.3691 59.9709C14.3691 62.571 16.5196 64.6643 19.0582 64.6643C16.3959 64.6643 14.367 66.6294 14.367 69.3555C14.367 66.7284 12.3622 64.6643 9.67578 64.6643C12.3622 64.6643 14.3691 62.5462 14.3691 59.9709Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 106,
    width: 22,
    height: 11
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3125 106.539H52.9541V116.268H31.3125V106.539Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1332 118.816C41.4228 118.816 40.7203 118.777 40.0256 118.698C39.327 118.62 38.6519 118.503 37.9964 118.349C37.341 118.194 36.7169 118.006 36.1282 117.782C35.5356 117.558 34.99 117.303 34.4876 117.019C33.9853 116.733 33.5378 116.423 33.1453 116.087C32.7489 115.753 32.4153 115.399 32.1445 115.026C31.8737 114.654 31.6696 114.27 31.5283 113.875C31.3909 113.479 31.3242 113.081 31.3242 112.677C31.3242 112.274 31.3909 111.874 31.5283 111.48C31.6696 111.085 31.8737 110.701 32.1445 110.328C32.4153 109.956 32.7489 109.602 33.1453 109.267C33.5378 108.932 33.9853 108.622 34.4876 108.336C34.99 108.052 35.5356 107.797 36.1282 107.573C36.7169 107.349 37.341 107.161 37.9964 107.005C38.6519 106.852 39.327 106.735 40.0256 106.657C40.7203 106.578 41.4228 106.539 42.1332 106.539C42.8436 106.539 43.5462 106.578 44.2409 106.657C44.9395 106.735 45.6146 106.852 46.27 107.005C46.9255 107.161 47.5495 107.349 48.1382 107.573C48.7309 107.797 49.2764 108.052 49.7788 108.336C50.2812 108.622 50.7286 108.932 51.1211 109.267C51.5175 109.602 51.8511 109.956 52.1219 110.328C52.3927 110.701 52.5968 111.085 52.7381 111.48C52.8755 111.874 52.9422 112.274 52.9422 112.677C52.9422 113.081 52.8755 113.479 52.7381 113.875C52.5968 114.27 52.3927 114.654 52.1219 115.026C51.8511 115.399 51.5175 115.753 51.1211 116.087C50.7286 116.423 50.2812 116.733 49.7788 117.019C49.2764 117.303 48.7309 117.558 48.1382 117.782C47.5495 118.006 46.9255 118.194 46.27 118.349C45.6146 118.503 44.9395 118.62 44.2409 118.698C43.5462 118.777 42.8436 118.816 42.1332 118.816Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 115,
    width: 18,
    height: 3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5156 115.172H50.7531V117.356H33.5156V115.172Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7531 116.264C50.7531 116.335 50.6953 116.406 50.5868 116.477C50.4748 116.547 50.3121 116.615 50.0952 116.681C49.8782 116.747 49.6143 116.81 49.2998 116.87C48.9853 116.929 48.6274 116.985 48.2261 117.035C47.8284 117.086 47.391 117.131 46.921 117.171C46.451 117.211 45.9557 117.244 45.4315 117.271C44.9073 117.299 44.3686 117.32 43.8155 117.334C43.2587 117.348 42.6984 117.355 42.1344 117.355C41.5668 117.355 41.0064 117.348 40.4533 117.334C39.8965 117.32 39.3579 117.299 38.8337 117.271C38.3131 117.244 37.8142 117.211 37.3442 117.171C36.8742 117.131 36.4367 117.086 36.0391 117.035C35.6378 116.985 35.2799 116.929 34.9653 116.87C34.6508 116.81 34.3869 116.747 34.17 116.681C33.9531 116.615 33.7904 116.547 33.6783 116.477C33.5699 116.406 33.5156 116.335 33.5156 116.264C33.5156 116.192 33.5699 116.121 33.6783 116.05C33.7904 115.98 33.9531 115.912 34.17 115.846C34.3869 115.779 34.6508 115.717 34.9653 115.657C35.2799 115.598 35.6378 115.542 36.0391 115.492C36.4367 115.441 36.8742 115.396 37.3442 115.356C37.8142 115.316 38.3131 115.283 38.8337 115.255C39.3579 115.228 39.8965 115.207 40.4533 115.193C41.0064 115.179 41.5668 115.172 42.1344 115.172C42.6984 115.172 43.2587 115.179 43.8155 115.193C44.3686 115.207 44.9073 115.228 45.4315 115.255C45.9557 115.283 46.451 115.316 46.921 115.356C47.391 115.396 47.8284 115.441 48.2261 115.492C48.6274 115.542 48.9853 115.598 49.2998 115.657C49.6143 115.717 49.8782 115.779 50.0952 115.846C50.3121 115.912 50.4748 115.98 50.5868 116.05C50.6953 116.121 50.7531 116.192 50.7531 116.264Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 49,
    width: 37,
    height: 37
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3398 49.2734H83.6035V85.5984H47.3398V49.2734Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_5396_20390)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 49,
    width: 37,
    height: 37
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4756 49.2812C55.4582 49.2812 47.3438 57.4094 47.3438 67.4437C47.3438 77.4734 55.4582 85.6062 65.4756 85.6062C75.4883 85.6062 83.6074 77.4734 83.6074 67.4437C83.6074 57.4094 75.4883 49.2812 65.4756 49.2812Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3438 49.2812H83.6074V85.6062H47.3438V49.2812Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 56,
    width: 23,
    height: 23
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1484 56.0859H76.7655V78.7413H54.1484V56.0859Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_5396_20390)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_5396_20390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 56,
    width: 23,
    height: 23
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4593 56.0859C59.2106 56.0859 54.1484 61.1567 54.1484 67.4159C54.1484 73.6705 59.2106 78.7413 65.4593 78.7413C71.7033 78.7413 76.7655 73.6705 76.7655 67.4159C76.7655 61.1567 71.7033 56.0859 65.4593 56.0859Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_5396_20390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1484 56.0859H76.7655V78.7413H54.1484V56.0859Z",
    fill: "#3D1F1E"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0193 69.0352C62.0193 66.3091 64.0483 64.344 66.7105 64.344C64.172 64.344 62.0215 62.2506 62.0215 59.6506C62.0215 62.2259 60.0145 64.344 57.3281 64.344C60.0145 64.344 62.0193 66.4081 62.0193 69.0352Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0193 59.6484L62.0215 59.6506M62.0215 59.6506C62.0215 62.2506 64.172 64.344 66.7105 64.344C64.0483 64.344 62.0193 66.3091 62.0193 69.0352C62.0193 66.4081 60.0145 64.344 57.3281 64.344C60.0145 64.344 62.0215 62.2259 62.0215 59.6506Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5396_20390",
    x1: 20.9173,
    y1: 32.6328,
    x2: 20.9173,
    y2: 66.4317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5396_20390",
    x1: 41.6011,
    y1: 0.273438,
    x2: 41.6011,
    y2: 47.8771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5396_20390",
    x1: 63.1344,
    y1: 32.6328,
    x2: 63.1344,
    y2: 66.4317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPikkopay2);
export default __webpack_public_path__ + "static/media/logo_pikkopay2.e186346e8b363413b0a819a263e9d0f2.svg";
export { ForwardRef as ReactComponent };